export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const UPLOAD_URL = process.env.REACT_APP_UPLOAD_URL;
